// URL Base
const url_base = $("#infos").data("url-base");

// DEBOUNCE (Melhora a performance de funções repetitivas como "Scroll / Resize")
const debounce = function (n, t, u) {
  var e;
  return function () {
    var a = this,
      i = arguments,
      o = function () {
        (e = null), u || n.apply(a, i);
      },
      r = u && !e;
    clearTimeout(e), (e = setTimeout(o, t)), r && n.apply(a, i);
  };
};

// Verifica se o tamanho da tela é menor do que o tamanho passado (Útil em caso de verificação de responsividade)
function isMobileX(screenSize) {
  return $(window).width() < screenSize;
}

// Formata um valor para real (R$)
function formatMoneyBR(v, c, d, t) {
  var n = v,
    c = isNaN((c = Math.abs(c))) ? 2 : c,
    d = d == undefined ? "," : d,
    t = t == undefined ? "." : t,
    s = n < 0 ? "-" : "",
    i = parseInt((n = Math.abs(+n || 0).toFixed(c))) + "",
    j = (j = i.length) > 3 ? j % 3 : 0;
  return (
    s +
    (j ? i.substr(0, j) + t : "") +
    i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
    (c
      ? d +
        Math.abs(n - i)
          .toFixed(c)
          .slice(2)
      : "")
  );
}

// Formata um valor em real (R$) para o formato do banco
function formatMoneyBD(value) {
  return value.replace(".", "").replace(",", ".");
}

// Copia uma string para a área de transferência
function copyToClipboard(str) {
  const el = document.createElement("textarea");
  el.value = str;
  el.setAttribute("readonly", "");
  el.style.position = "absolute";
  el.style.left = "-9999px";
  document.body.appendChild(el);
  const selected =
    document.getSelection().rangeCount > 0
      ? document.getSelection().getRangeAt(0)
      : false;
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);
  if (selected) {
    document.getSelection().removeAllRanges();
    document.getSelection().addRange(selected);
  }
}

// Gera um slug
function slugify(text) {
  return text
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "")
    .replace(/--+/g, "-");
}

// Lazy load
window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.loadMode = 1;
